import React from "react";

const Video = React.lazy(() => import("@/views/video"));
const Home = React.lazy(() => import("@/views/home/home"));
const routes = [
  {
    path: "/",
    element: <Video />,
  },
  {
    path: "/home",
    element: <Home />,
  },
];
export default routes;
